import { memo } from "react";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useCommentContext } from "../../../providers";

type Props = {
    readonly index: number;
};

const CommentMessage = ({ index }: Props) => {
    const { comments, deleteMessage } = useCommentContext();

    return (
        <Alert
            severity='success'
            action={(
                <IconButton
                    size='small'
                    onClick={() => deleteMessage(index)}
                >
                    <DeleteForeverIcon />
                </IconButton>
            )}
        >
            {comments[index]}
        </Alert>
    );
};

export default memo(CommentMessage);
